import { connect } from 'react-redux';

import CouponsInfoSection from '../components/CouponsInfoSection';
import { COUPONS_INFO_SECTION_COOKIE } from '../consts';
import {
  collapseInfoSection,
  expandInfoSection,
} from 'apps/coupons/actions/coupons';

export default connect(
  state => ({
    collapsed: (
      (
        state.userPreferences[COUPONS_INFO_SECTION_COOKIE.name] === 'true' &&
        state.coupons.isInfoSectionCollapsed !== false
      ) ||
      state.coupons.isInfoSectionCollapsed === true
    ),
  }), {
    collapseInfoSection,
    expandInfoSection,
  }
)(CouponsInfoSection);
